import en from "../../../Extensions/salbase9/Resources/Private/JSON/Countries/en.json";
import de from "../../../Extensions/salbase9/Resources/Private/JSON/Countries/de.json";
import fr from "../../../Extensions/salbase9/Resources/Private/JSON/Countries/fr.json";
import nl from "../../../Extensions/salbase9/Resources/Private/JSON/Countries/nl.json";
import it from "../../../Extensions/salbase9/Resources/Private/JSON/Countries/it.json";
import cs from "../../../Extensions/salbase9/Resources/Private/JSON/Countries/cs.json";
import zh from "../../../Extensions/salbase9/Resources/Private/JSON/Countries/zh.json";

const countriesByLang = {en, de, fr, nl, it, cs, zh};

const euCountries = ["DE", "BE", "BG", "DK", "EE", "FI", "FR", "GR", "NL", "IT", "IE", "HR", "LV", "LU", "LT", "MT", "AT", "PL", "PT", "RO", "SE", "SK", "SI", "ES", "CZ", "HU", "CY"];

const countries = () => {
    let lang = "en";

    if (window.language && countriesByLang[window.language]) {
        lang = window.language;
    }

    let countries = Object.assign({}, countriesByLang[lang]["countries"]);

    for (let key in countries) {
        countries[key] = typeof countries[key] === "string" ? countries[key] : countries[key][0];
    }

    return countries
}
const countryNameForIso2 = (iso2) => {
    if (!iso2) {
        return null;
    }

    const country = countries()[iso2.toUpperCase()];

    return typeof country === "string" ? country : country[0];
}

const isInEu = (key) => {
    return euCountries.indexOf(key) !== -1
}

const defaultCountryForMarket = () => {
    switch (window.market) {
    case "DACH":
        return "DE"
    case "NL":
        return "NL"
    case "FR":
        return "FR"
    case "IT":
        return "IT"
    case "CZ":
        return "CZ"
    case "Nordics":
        return "SE"
    case "UK":
        return "GB"
    case "PL":
        return "PL"
    case "ROW":
        return "DE"
    case "AU":
        return "AU"
    default:
        return "DE"
    }
}

const getUserCountry = () => {
    return window.PFL_AUTH_COUNTRY ? window.PFL_AUTH_COUNTRY : defaultCountryForMarket()
}

export {
    countries,
    countryNameForIso2,
    getUserCountry,
    isInEu
}
